import { render, staticRenderFns } from "./EditDeleteGroup.vue?vue&type=template&id=3b12e34e&"
import script from "./EditDeleteGroup.vue?vue&type=script&lang=js&"
export * from "./EditDeleteGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports